<template>
    <div class="d-flex justify-content-between" style="width: 100%;">
      <dropdown
        :options="categoryOptions"
        :value="selectedCategory"
        :onChange="val => $emit('change', val)"
        :placeholder="required ? 'Team*' : 'Team'"
      />

      <dropdown
        v-if="subCategoryOptions"
        :options="subCategoryOptions"
        :value="selectedSubCategory"
        :onChange="val => $emit('change', val)"
        placeholder="Sub-Category"
      />

  <!--    <CategorySelect-->
  <!--      v-if="subCategories.length"-->
  <!--      :category-options="subCategories"-->
  <!--      :value="value"-->
  <!--      @change="$emit('change', $event)"-->
  <!--    />-->
    </div>
</template>

<script>
import Dropdown from "@/components/Dropdown";
// import {mapGetters} from "vuex";
export default {
  name: "CategorySelect",
  components: {Dropdown},
  props: {
    value: {
      type: Number
    },
    categories: {
      type: Object,
      default: () => ({})
    },
    required: {
      type: Boolean,
      default: false
    }
  },
  // data(){
  //   return {
  //     localVal: null
  //   }
  // },
  // watch: {
  //   value: {
  //     immediate: true,
  //     handler(newVal, oldVal) {
  //       if (newVal !== oldVal) this.localVal = newVal
  //     }
  //   }
  // },
  // methods:{
  // },
  computed: {
    subCategories(){
      return Object.values(this.categories).reduce((obj, el) => {
        if(el.subCategories && el.subCategories.length) {
          el.subCategories.forEach(subCat => {
            obj[subCat.id] = subCat
          })
        }
        return obj
      }, {})
    },
    categoryOptions(){
      return Object.values(this.categories).map(cat => ({text: cat.name, value: cat.id}))
    },
    selectedCategory(){
      return (!!this.value && this.categories[this.value]) ? this.value :
        (this.selectedSubCategory ? this.subCategories[this.selectedSubCategory].categoryId : undefined);
    },
    subCategoryOptions(){
      const selectedCategory = this.selectedCategory && this.categories[this.selectedCategory];
      const subCategories = (selectedCategory
        && Array.isArray(selectedCategory.subCategories)
        && selectedCategory.subCategories.length) ? selectedCategory.subCategories : false;
      return subCategories ? subCategories.map(el => ({text: el.name, value: el.id, })) : undefined;
    },
    selectedSubCategory(){
      return (!!this.value && this.subCategories[this.value]) ? this.value : undefined;
    }
  }
  // computed: {
  //   categoryOptions(){
  //     console.log('categoryOptions')
  //     return Object.keys(this.categories).map(key => {
  //       const cat = this.categories[key]
  //       return {value: cat.id, text: cat.name};
  //     });
  //   },
  //   subCategoryMap(){
  //     console.log('subCategoryMap')
  //     return Object.keys(this.categories).reduce((obj, key) => {
  //       const subCategories = this.categories[key].subCategories;
  //       obj[key] = !subCategories ? [] :
  //         subCategories.reduce((subArr, subCat) => {
  //           subArr.push({value: subCat.id, text: subCat.name})
  //           return subArr
  //         }, [])
  //       return obj
  //     }, {})
  //   },
  //   subCategoryIndex(){
  //     console.log('subCategoryIndex')
  //     return Object.keys(this.subCategoryMap).reduce((obj, key) => {
  //       obj[key] = this.subCategoryMap[key].map((el) => el.value)
  //       return obj
  //     }, {})
  //   },
  //   selectedCategory(){
  //     console.log('selectedCategory')
  //     if(!this.localVal) return undefined;
  //     if(this.subCategoryIndex[this.localVal]) return this.localVal;
  //     return Object.keys(this.subCategoryIndex).find(el => this.subCategoryIndex[el].includes(this.localVal))
  //   },
  //   subCategoryOptions(){
  //     console.log('subCategoryOptions')
  //     if(!this.selectedCategory) return undefined;
  //     console.log(this.subCategoryMap[this.selectedCategory])
  //     return this.subCategoryMap[this.selectedSubCategory]
  //   },
  //   selectedSubCategory(){
  //     console.log('selectedSubCategory')
  //     if(!this.subCategoryOptions) return null;
  //     return this.subCategoryOptions.find(el => el.value === this.localVal) ? this.localVal : undefined;
  //   },
  // }
}
</script>

<style scoped>

</style>
